import { format } from "date-fns";

import { parseTrialEndDate } from "./parseTrialEndDate";

// Formats an ISO trial-end timestamp as "MMMM d, yyyy" (MEM-520). All parsing
// + overflow handling lives in parseTrialEndDate so the two trial consumers
// can't drift.
export const formatTrialEndDate = (
  isoDateString: string | undefined,
): string | null => {
  const parsed = parseTrialEndDate(isoDateString);
  if (!parsed) {
    return null;
  }
  return format(parsed, "MMMM d, yyyy");
};
